module.exports = __webpack_public_path__ + "static/media/pic_group@2x.9abcf7cf.png";